import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
